import React from 'react';
import ReactDOM from 'react-dom/client';
// import "./index.css";
import App from './App';
import './logLevel';
import './sitecoreWidgetsConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
